import Page from './index'

import HeadInch from './headInch'
import Active from './active'
import Plan from './plan'
import ProfitLoss from './profit'
import MoveProfitLoss from './moveProfit'
export default {
  path: '/home/tiger',
  component: Page,
  meta: { titie: '合约持仓管理' },
  children: [
    {
      path: '/home/tiger/head-inch',
      meta: { titie: '仓位净头寸' },
      component: HeadInch,
    },
    {
      path: '/home/tiger/active',
      meta: { titie: '限价委托' },
      component: Active,
    }, //限价委托
    {
      path: '/home/tiger/plan',
      meta: { titie: '计划委托' },
      component: Plan,
    }, //计划委托
    {
      path: '/home/tiger/profitLoss',
      meta: { titie: '止盈止损' },
      component: ProfitLoss,
    }, //止盈止损
    {
      path: '/home/tiger/moveProfitLoss',
      meta: { titie: '止盈止损' },
      component: MoveProfitLoss,
    }, // 移动止盈止损
  ],
}
